/* eslint-disable no-undef */
import Cookies from 'js-cookie'
import axios from 'axios'
import qs from 'qs'
import dayjs from 'dayjs'
import shortid from 'shortid'

// 支持跨域请求携带cookie
axios.defaults.withCredentials = true

let errFn = (error) => {
  if (error.response) {
    return error.response.data
  } else {
    return { error_code: 400, msg: error.message || error.msg }
  }
}
export default {
  assemblingData(data) {
    // if (typeof (data) === 'object') {
    //   data._xsrf = Cookies.get('_xsrf')
    // } else {
    //   data = {}
    //   data._xsrf = Cookies.get('_xsrf')
    // }
    return data
  },
  post(url, data = {}) {
    data = this.assemblingData(data)
    return axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err, this)
    })
  },
  postJson(url, data = {}, options = {}) {
    data = this.assemblingData(data)

    if (options.contentType !== 'application/json') {
      data = qs.stringify(data)
    }

    return axios.post(url, data, {
      headers: {
        'Content-Type': options.contentType || 'application/x-www-form-urlencoded'
      }
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err, this)
    })
  },
  postJsonIM(url, data = {}, options = {}) {
    return axios.post(url, JSON.stringify(data), {
      headers: {
        'Content-Type': options.contentType || 'application/json'
      }
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err)
    })
  },
  getJson(url, data = {}) {
    return axios.get(url + '?ts=' + new Date().getTime(), { params: data }).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err)
    })
  },
  deleteJson(url, data = {}) {
    data = this.assemblingData(data)
    return axios.delete(url, { params: data }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err)
    })
  },
  putJson(url, data = {}) {
    data = this.assemblingData(data)
    return axios.put(url, qs.stringify(data), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err)
    })
  },
  postFile(url, data) {
    // data.append('_xsrf', Cookies.get('_xsrf'))
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, data, config).then((res) => {
      return res.data
    }).catch((err) => {
      return errFn(err)
    })
  },
  postFileProgress(url, data, callback, source) {
    data.append('_xsrf', Cookies.get('_xsrf'))
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: callback,
      cancelToken: source.token
    }
    return axios.post(url, data, config).then((res) => {
      return res.data
    }).catch((err) => {
      if (axios.isCancel(err)) {
        console.log('Request canceled', err.message)
      } else {
        return errFn(err)
      }
    })
  },
  /**
   * 对象格式化 为 urlencode
   */
  encodeUrl(obj) {
    let urls = ''
    let kvArr = Object.entries(obj)
    kvArr.forEach(v => {
      if (Object.prototype.toString.call(v[1]) === '[object Object]') {
        arguments.callee(v[1])
      } else {
        urls += v.join('=') + '&'
      }
    })
    return urls.substring(0, urls.length - 1)
  },
  /**
   * html解析
   * @param val{String}字符串
   */
  html_decode(str) {
    let s = ''
    if (str) {
      if (str.length === 0) return ''
      s = str.replace(/&amp;/g, '&')
      s = s.replace(/&lt;/g, '<')
      s = s.replace(/&gt;/g, '>')
      s = s.replace(/&nbsp;/g, ' ')
      s = s.replace(/&#39;/g, '\'')
      s = s.replace(/&quot;/g, '\'')
      s = s.replace(/<br>/g, '\n')
    }
    return s
  },
  removeHTMLTag(str) {
    if (str) {
      str = str.toString().replace(/(\n)/g, '')
      str = str.replace(/(\t)/g, '')
      str = str.replace(/(\r)/g, '')
      str = str.replace(/<\/?[^>]*>/g, '')
      str = str.replace(/\s*/g, '')
      return str
    } else {
      return ''
    }
  },
  /**
   * 获取文字的字符数量(中文及中文符号转化为2个字符)
   * @param val{String}文字信息
   */
  getCharLen(val) {
    if (val) {
      return val.replace(/[^\\x00-\\xff]/g, 'xx').length
    } else {
      return 0
    }
  },
  /* 计算两个Date类型时间差，以hh:mm:ss格式返回 */
  getDiff(start, end) {
    let diffStr = ''
    let difference = end.getTime() - start.getTime()
    if (difference > 0) {
      let hour = Math.floor(difference / (1000 * 60 * 60))
      let minute = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      let second = Math.floor((difference % (1000 * 60 * 60)) % (1000 * 60) / 1000)
      if (parseInt(hour, 10) < 10) {
        hour = '0' + parseInt(hour, 10)
      }
      if (parseInt(minute, 10) < 10) {
        minute = '0' + parseInt(minute, 10)
      }
      if (parseInt(second, 10) < 10) {
        second = '0' + parseInt(second, 10)
      }
      diffStr = hour + ':' + minute + ':' + second
    }
    return diffStr
  },

  /**
   * 获取url参数
   */
  getQueryString(name, path) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let search = path || decodeURI(decodeURIComponent(window.location.search))
    var r = search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },

  /**
   * 获取uuid 方法
   */
  getUuid() {
    return window.location.pathname.match(/[0-9a-f]{16,16}/g)
  },
  /**
   * 获取uuid 方法
   */
  getId() {
    return window.location.pathname.match(/\d+/g)
  },
  /**
   * 格式化< > 字符
   * @param val(string)
   */
  decodeHtml(text) {
    let msg = text
    msg = msg.replace(/&lt;/g, '<')
    msg = msg.replace(/&gt;/g, '>')
    return msg
  },
  /**
   * 格式化 @内容
   * @param val{String}@ 原数据
   */
  decodeAtMsg(text, isNofity) {
    if (!text) return ''
    let msg = text
    msg = msg.replace(/\n/g, '【【br】】')
    msg = msg.replace(/\s/g, '&ensp;')
    // 解析 @ta
    msg = msg.replace(/&lt;/g, '<')
    msg = msg.replace(/&gt;/g, '>')
    if (isNofity) {
      msg = msg.replace(/<@([^|]+)\|([^>]+)>/g, '@$2')
    } else {
      msg = msg.replace(/<@([^|]+)\|([^>]+)>/g, '【【span data-uuid="$1" class="atta"】】@$2【【/span】】 ')
    }
    msg = msg.replace(/【【/g, '<')
    msg = msg.replace(/】】/g, '>')
    return msg
  },
  /**
  转换后端传回的日期串
  */
  getDate(val, type, isMillisecond = true) {
    let time = new Date()
    if (val) {
      time = isMillisecond ? new Date(val * 1000) : new Date(val.toString().replace(/-/g, '/'))
    }
    let year = time.getFullYear()
    let _month = time.getMonth() + 1
    let month = _month < 10 ? '0' + _month : _month
    let date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
    let hour = time.getHours()
    hour = hour < 10 ? '0' + hour : hour
    let minutes = time.getMinutes()
    minutes = minutes < 10 ? '0' + minutes : minutes
    let seconds = time.getSeconds()
    seconds = seconds < 10 ? '0' + seconds : seconds
    let result = ''
    switch (type) {
      case 'y.m': // 2016.11
        result = year + '.' + month
        break
      case 'ym': // 2016.11.23
        result = year + '.' + month + '.' + date
        break
      case 'md': // 11.23
        result = month + '.' + date
        break
      case 'hm': // 10:56
        result = hour + ':' + minutes
        break
      case 'mdhm': // 11-23 10:56
        result = month + '-' + date + ' ' + hour + ':' + minutes
        break
      case 'hms': // 10:56:09
        result = hour + ':' + minutes + ':' + seconds
        break
      case 'm': // 06
        result = minutes
        break
      case 'm-d': // 11-23
        result = month + '-' + date
        break
      case 'ymhs': // 2016.11.23 10:56
        result = year + '.' + month + '.' + date + ' ' + hour + ':' + minutes
        break
      case 'ymhss': // 2016.11.23 10:56:00
        result = year + '.' + month + '.' + date + ' ' + hour + ':' + minutes + ':' + seconds
        break
      case 'ymdhms': // 20161123105600
        result = year + '' + month + '' + date + '' + hour + '' + minutes + '' + seconds
        break
      case 'y-mhs': // 2016-11-23 10:56
        result = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes
        break
      case 'ymdhm': // 2016-11-23
        result = year + '-' + month + '-' + date
        break
      case 'mdyr': // 11月23日
        result = month + '月' + date + '日 '
        break
      case 'ymd': // 2013年11月23日
        result = year + '年' + month + '月' + date + '日 '
        break
      case 'year': // 2016
        result = year
        break
      case 'task':
        let day = (new Date()).getDate()
        let nowDate = (new Date())
        result = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes
        let diff = dayjs(nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + day).diff(dayjs(year + '-' + month + '-' + date), 'day')
        if (diff === 0) {
          result = '今天 ' + hour + ':' + minutes
        } else if (diff === 1) {
          result = '昨天 ' + hour + ':' + minutes
        }
        break
      default:
        result = year + '-' + month
    }
    return result
  },

  /**
    格式化金钱，加千位分隔符
  */
  getMoney(val, isWan) {
    if (isWan && val >= 10000) {
      return (val / 10000) + '万'
    } else {
      return val ? val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') : val
    }
  },
  /**
   *
   * @param {*获取附件size} val
   */
  getSize(val) {
    if (val < 1048576) {
      return (val / 1024).toFixed(2) + 'KB'
    } else {
      return (val / 1048576).toFixed(2) + 'MB'
    }
  },
  /**
   * 获取下吧
   */
  findIndex(arr, key, val) {
    let idx = -1
    if (Object.prototype.toString.call(arr) === '[object Array]') {
      arr.forEach((item, i) => {
        if (item[key] === val) {
          idx = i
        }
      })
    }
    return idx
  },
  /**
   * 获取当前日期字符串
   */
  getNowDateStr() {
    let now = new Date()
    let getyear = now.getFullYear()
    let getmonth = now.getMonth() + 1
    let getdate = now.getDate()
    if (getmonth < 10) {
      getmonth = '0' + getmonth.toString()
    }
    if (getdate < 10) {
      getdate = '0' + getdate.toString()
    }
    return getyear.toString() + '/' + getmonth.toString() + '/' + getdate
  },
  /**
   * html转义
   * @param val{String}字符串
   */
  html_encode(str) {
    let s = ''
    if (str) {
      if (str.length === 0) return ''
      s = str.replace(/&/g, '&amp;')
      s = s.replace(/</g, '&lt;')
      s = s.replace(/>/g, '&gt;')
      s = s.replace(/\'/g, '&quot;')
    }
    return s
  },
  /**
   * 删除数组元素指定元素
   */
  removeArr(val, arr) {
    let index = arr.indexOf(val)
    if (index > -1) {
      arr.splice(index, 1)
    }
  },
  alertFn(type, msg, callback) {
    let _alert = document.getElementById('weekAlert')

    // 如果不存在则添加元素到body里面
    if (!_alert) {
      let wk = document.createElement('div')
      wk.className = 'week-alert'
      wk.id = 'weekAlert'
      document.body.appendChild(wk)
      _alert = document.getElementById('weekAlert')
      let ac = document.createElement('span')
      ac.className = 'alert-content'
      ac.id = 'alert-content'
      _alert.appendChild(ac)
    }

    // 填充内容
    document.getElementById('alert-content').innerText = msg
    // 处理不同状态的样式
    _alert.className = type === 'success' ? 'week-alert alert-success alert-show' : 'week-alert alert-error alert-show'

    // 间隔2.5s隐藏
    setTimeout(() => {
      _alert.className = _alert.className.replace('alert-show', '')
    }, 2500)
  },
  /**
   * 添加事件
   * @param {Object} obj 被添加事件的对象
   * @param {String} xEvent  事件名称
   * @param {Function} fn 事件执行函数
   */
  addEvent(obj, xEvent, fn) {
    if (obj.attachEvent) {
      obj.attachEvent('on' + xEvent, fn)
    } else {
      obj.addEventListener(xEvent, fn, false)
    }
  },
  // 移除事件
  removeEvent(obj, xEvent, fn) {
    if (obj.detachEvent) {
      obj.detachEvent('on' + xEvent, fn)
    } else {
      obj.removeEventListener(xEvent, fn, false)
    }
  },
  /**
   * 注销事件
   * @param {*} obj
   * @param {*} xEvent
   */
  offEvent(obj, xEvent) {
    obj.removeEventListener(xEvent, this)
  },
  /**
   * 跳转登录
   */
  goLogin(key = 'signin', path) {
    let loc = window.location
    if (loc.hostname === 'localhost' || loc.hostname.indexOf('191.168') >= 0) {
      window.location.href = '/login?redirect=' + loc.pathname
    } else {
      let url = `${PASSPORT_DOMAIN}/${key}`;
      if (!path) {
        path = encodeURIComponent(loc.href)
      } else {
        path = encodeURIComponent(path)
      }
      window.location.href = `${url}?return_url=${path}`
    }
  },
  /**
   * 深度克隆
   * @param {Object} data
   */
  deepCopy(obj, deep) {
    let _self = this
    // 类型判断
    let isArray = (item) => {
      return Object.prototype.toString.call(obj) === '[object Array]'
    }

    if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
      return obj
    }

    if (typeof obj === 'function') {
      return new Function('return ' + obj.toString())()
    } else {
      var name = null
      var target = isArray(obj) ? [] : {}
      let value = null

      for (name in obj) {
        value = obj[name]
        if (value === obj) {
          continue
        }

        if (deep && (isArray(value) || typeof value === 'object')) {
          target[name] = _self.deepCopy(value, deep)
        } else {
          target[name] = value
        }
      }
      return target
    }
  },
  /**
   * 节流函数
   * @param {Function} fn 被执行行数
   * @param {Number} wait 需要等待的时间(毫秒)
   * @param {Number} mustRun 多少毫秒必须执行一次
   */
  throttle(fn, wait, mustRun) {
    let timeout = null
    let start = new Date()
    return () => {
      let ctx = this
      let args = arguments
      let curTime = new Date()
      clearTimeout(timeout)
      // 如果达到了规定的触发时间间隔，触发 handler
      if (curTime - start >= mustRun) {
        fn.apply(ctx, args)
        start = curTime
        // 没达到触发间隔，重新设定定时器
      } else {
        timeout = setTimeout(fn, wait)
      }
    }
  },
  /**
  * 获取域名前缀
  * @param {string} key 类型: resident：黄豆，yunxun：沃客信, ent: 企业版，monitor： 效率监控,org: 组织机构, crm：crm客户管理，appraise：估价器，passport：单点登录，task：任务管理系统，wssent：企业版socket链接地址，wsstask：任务管理socket链接地址，wssresident：黄豆socket链接地址，www: 主站地址。
  */
  getSitePreUrl: (() => {
    const config = {
      prod: {
        resident: '//h.clouderwork.com',
        yunxun: '//i.clouderwork.com',
        ent: '//e.clouderwork.com',
        monitor: '//em.clouderwork.com',
        org: '//org.clouderwork.com',
        crm: '//newcrm.clouderwork.com',
        appraise: '//appraise.clouderwork.com',
        passport: '//passport.clouderwork.com',
        task: '//task.clouderwork.com',
        www: '//www.clouderwork.com',
        edoc: '//edoc.clouderwork.com',
        wssent: 'wss://e.clouderwork.com/api/feeds/ws',
        wsstask: 'wss://task.clouderwork.com/api/feeds/ws',
        wssresident: 'wss://zhaopin.clouderwork.com/websocket/feeds'
      },
      beta: {
        resident: '//beta-resident.yunwoke.com',
        yunxun: '//beta-yunxun.yunwoke.com',
        ent: '//beta-ent.yunwoke.com',
        monitor: '//beta-monitor.yunwoke.com',
        org: '//beta-org.yunwoke.com',
        crm: '//beta-crm.yunwoke.com',
        appraise: '//beta-appraise.yunwoke.com',
        passport: '//beta-passport.yunwoke.com',
        task: '//beta-task.yunwoke.com',
        www: '//beta.yunwoke.com',
        edoc: '//beta-edoc.yunwoke.com',
        wssent: 'wss://beta-ent.yunwoke.com/api/feeds/ws',
        wsstask: 'wss://beta-task.yunwoke.com/api/feeds/ws',
        wssresident: 'wss://beta-resident.yunwoke.com/websocket/feeds'
      },
      test: {
        resident: '//resident.yunwoke.com',
        yunxun: '//yunxun.yunwoke.com',
        ent: '//ent.yunwoke.com',
        monitor: '//monitor.yunwoke.com',
        org: '//org.yunwoke.com',
        crm: '//crm2.yunwoke.com',
        appraise: '//appraise.yunwoke.com',
        passport: '//passport.yunwoke.com',
        task: '//task.yunwoke.com',
        www: '//test.yunwoke.com',
        edoc: '//edoc.yunwoke.com',
        wssent: 'wss://ent.yunwoke.com/api/feeds/ws',
        wsstask: 'wss://task.yunwoke.com/api/feeds/ws',
        wssresident: 'wss://resident.yunwoke.com/websocket/feeds'
      }
    }
    const origin = window.location.origin
    const env = origin.includes('clouderwork') ? 'prod' : (origin.includes('beta') ? 'beta' : 'test')
    return (app) => {
      return config[env][app] || config[env]['www']
    }
  })(),
  createDeviceID() {
    return window.navigator.productSub + '' + shortid.generate()
  }
}
